import locationRawData from "rawData/locationRawData";
import lang from "./resourse";
const neighborRawDataV1 = [
  {
    "name": "維克多",
    "description": "鎮長",
    "locations": ['鎮公所'],
    "first": [
      "珠寶哈密瓜",
      "發光手錶"
    ],
    "second": [
      "哈密瓜",
      "拌飯",
      // "松茸",
      // "玉蜀黍",
      "白飯",
      "哈密瓜果醬",
      "栗子飯",
      "松茸炊飯",
    ],
    "third": [ // Simple Street Lamp, Umbrella Table
      "花香香水",
      "春風進行曲",
      "珠寶戒指",
      // "營火",
      "氣派的路燈",
      "豪華路燈",
      "木製長椅",
      "鐵製長椅",
      "炎帝華爾滋",
      "魅惑香水",
      "大地協奏曲",
      "時髦手環",
      "果香香水",
      "珠寶墜子",
      "月夜夜曲",
      "彩虹花束",
      "雪花輪舞曲",
      "百花香水",
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "雅科波",
    "description": "橄欖鎮吉祥物/鎮長兒子",
    "locations": ['鎮公所'],
    "first": [
      "鑽石",
      "巨大海鮮披薩",
      "發光手錶"
    ],
    "second": [
      "義大利漁夫麵",
      "青醬義大利麵",
      "披薩",
      "蔬食披薩",
      "日式拿坡里義大利麵",
      "蒜味辣椒義大利麵",
      "珠寶墜子",
      "時髦手環",
      "花香香水",
      "百花香水",
    ],
    "third": [
      "果香香水",
      "魅惑香水",
      "春風進行曲",
      "炎帝華爾滋",
      "珠寶戒指",
      "大地協奏曲",
      "雪花輪舞曲",
      "彩虹花束",
      "月夜夜曲",
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "葛爾克",
    "description": "船長",
    "locations": ['動物商店'],
    "first": [
      "愛心菠菜",
      "頂級雞蛋",
      "頂級烏骨雞蛋",
      "雞蛋沙拉",
      "星型馬鈴薯",
    ],
    "second": [
      "雞蛋",
      "烏骨雞蛋",
      "羊毛毛料",
      "馬鈴薯沙拉",
      "荷包蛋",
      "黑森林蛋糕",
      "地瓜燒",
      "雞蛋三明治",
      "蜂蜜地瓜燒",
      "焗烤洋蔥湯",
      "馬鈴薯",
      "碗豆燉飯",
      "發光手錶",
      "菠菜",
      "黃色蔬菜濃湯",
    ],
    "third": [
      "羊毛",
      "頂級羊毛",
      "羊毛線",
      "花香香水",
      "魅惑香水",
      "時髦手環",
      "珠寶墜子",
      "珠寶戒指",
      "果香香水",
      "百花香水",
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "奈吉爾",
    "description": "木匠",
    "locations": ['木工店'],
    "first": [
      "發光手錶"
    ],
    "second": [
      "果醬三明治",
      "蔬菜三明治",
      "雞蛋三明治",
      "鮪魚三明治"
    ],
    "third": [
      '炎帝華爾滋',
      '百花香水',
      '磚頭加工機',
      '魅惑香水',
      '大地協奏曲',
      '時髦手環',
      '花香香水',
      '果香香水',
      '巨大磚頭加工機',
      '巨大金屬塊加工機',
      '巨大木材加工機',
      '巨大絲線加工機',
      '金屬塊加工機',
      '珠寶墜子',
      '珠寶戒指',
      '木材加工機',
      '夢幻原木',
      '夢幻木材',
      '月夜夜曲',
      '彩虹花束',
      '春風進行曲',
      '絲線加工機',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "傑森",
    "description": "旅館老闆",
    "locations": ['旅館＆咖啡廳'],
    "first": [
      "老舊的羅盤",
      "老舊的地圖"
    ],
    "second": [
      '杏仁餅乾',
      '魅惑香水',
      '巧克力餅乾',
      '椰子',
      '椰子汁',
      '餅乾',
      '時髦手環',
      '扶桑花',
      '珠寶墜子',
      '發光手錶'
    ],
    "third": [
      '炎帝華爾滋',
      '百花香水',
      '大地協奏曲',
      '花香香水',
      '果香香水',
      '珠寶戒指',
      '月夜夜曲',
      '彩虹花束',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "麥奇",
    "description": "小胖子",
    "locations": ['旅館＆咖啡廳'],
    "first": [
      "香蕉"
    ],
    "second": [
      // "可可亞",
      '龍涎香',
      '黑色古文書',
      '古代節肢動物化石',
      '古代貝類化石',
      '白色古文書',
      '古代飾品',
      '古代擺飾',
      '古代鏡子',
      '古代石碑',
      '水砷鐵銅石',
      '軟軟球',
      '地瓜燒',
      '洞穴珍珠',
      '可可豆',
      '黃金牛角頭盔',
      '琥珀結晶',
      '咖哩飯',
      '沙漠玫瑰',
      '恐龍化石',
      '高級寵物零食',
      '黑色古文書的仿製品',
      '古代節肢動物化石的仿製品',
      '古代貝類化石的仿製品',
      '白色古文書的仿製品',
      '古代擺飾的仿製品',
      '古代鏡子的仿製品',
      '古代石碑的仿製品',
      '黃金牛角頭盔的仿製品',
      '恐龍化石的仿製品',
      '玻璃鞋的仿製品',
      '黃金號角的仿製品',
      '古老的齒輪的仿製品',
      '閃亮的冠軍皮帶扣的仿製品',
      '閃亮的馬刺的仿製品',
      '老舊的硬幣的仿製品',
      '老舊的羅盤的仿製品',
      '老舊的團扇的仿製品',
      '老舊的地圖的仿製品',
      '老舊的卷軸的仿製品',
      '閃電熔結岩',
      '球馬陸雕像',
      '巨大海鮮披薩',
      '吉丙隕石',
      '玻璃鞋',
      '黃金號角',
      '焗烤通心粉',
      '大鍬形蟲雕像',
      '蜂蜜牛奶可可',
      '蜂蜜地瓜燒',
      '大藍閃蝶雕像',
      '日式拿坡里義大利麵',
      '兔尾石',
      '橄欖結晶',
      '美式鬆餅',
      '橄欖隕鐵',
      '寵物零食',
      '披薩',
      '古老的齒輪',
      '日本獨角仙雕像',
      '閃亮的冠軍皮帶扣',
      '閃亮的馬刺',
      '長戢獨角仙雕像',
      '鳳蝶雕像',
      '老舊的硬幣',
      '老舊的羅盤',
      '老舊的團扇',
      '老舊的地圖',
      '老舊的卷軸',
      '紋白蝶雕像'
    ],
    "third": [
      '杏仁餅乾',
      '烤蘋果',
      '黑森林蛋糕',
      '三種牡丹餅',
      '布朗尼蛋糕',
      '起司蛋糕',
      '栗子最中餅',
      '巧克力蛋糕',
      '巧克力餅乾',
      '巧克力瑪芬蛋糕',
      '咖啡布丁',
      '餅乾',
      '糖漬水果',
      '水果蛋糕',
      '玻璃',
      '玻璃石',
      '金塊',
      '金礦石',
      '蜂蜜布丁',
      '蜂蜜優格',
      '黃豆粉烤年糕吐司',
      '鐵塊',
      '鐵礦石',
      '芒果糯米飯',
      '拉明頓蛋糕',
      '楓糖瑪芬蛋糕',
      '蒙布朗',
      '艾草大福',
      '堅果瑪芬蛋糕',
      '奧利哈鋼金屬塊',
      '奧利哈鋼礦石',
      '紅豆麻糬湯',
      '西班牙杏仁糕點',
      '義式奶酪',
      '布丁',
      '鑽石原石',
      '祖母綠原石',
      '紅綠柱石原石',
      '紅寶石原石',
      '藍寶石原石',
      '白色蛋白石原石',
      '薩赫蛋糕',
      '草莓奶油蛋糕',
      '銀塊',
      '銀礦石',
      '草莓大福',
      '提拉米蘇'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "克萊門斯",
    "description": "升級工具和背包",
    "locations": ['工具行'],
    "first": [
      "芬蘭甜菜沙拉",
      "栗子飯",
      "蒙布朗",
      "發光手錶"
    ],
    "second": [
      '香料咖哩炒秋葵',
      '燉馬鈴薯',
      '西班牙風醃漬沙丁魚',
      '西班牙式鐵板煎菇',
      '栗子最中餅',
      '時髦手環',
      '果香香水',
      '大蒜',
      '義式烤扁鱈',
      '珠寶墜子',
      '珠寶戒指',
      '奧利哈鋼金屬塊',
      '蒜味辣椒義大利麵',
      '酸黃瓜',
      '西班牙香蒜湯',
      '法式煎蔬菜'
    ],
    "third": [
      '炎帝華爾滋',
      '日式煮魚',
      '百花香水',
      '魅惑香水',
      '栗子',
      '大地協奏曲',
      '花香香水',
      '巨大金屬塊加工機',
      '巨大珠寶加工機',
      '金塊',
      '金屬塊加工機',
      '鐵塊',
      '珠寶加工機',
      '豆皮烏龍麵',
      '月夜夜曲',
      '奧利哈鋼礦石',
      '彩虹花束',
      '鑽石原石',
      '祖母綠原石',
      '紅綠柱石原石',
      '紅寶石原石',
      '藍寶石原石',
      '煤炭',
      '銀塊',
      '春風進行曲',
      '天婦羅',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "拉修",
    "description": "機車男",
    "locations": ['工具行'],
    "first": [
      "栗子飯",
      "披薩",
      "蒙布朗",
      "魅惑香水",
      "時髦手環",
      "發光手錶"
    ],
    "second": [
      '栗子最中餅',
      '巨大海鮮披薩',
      '珠寶墜子',
      '珠寶戒指',
      '芬蘭甜菜沙拉',
      '蔬食披薩'
    ],
    "third": [
      '炎帝華爾滋',
      '百花香水',
      '栗子',
      '大地協奏曲',
      '花香香水',
      '果香香水',
      '月夜夜曲',
      '彩虹花束',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "賽門",
    "description": "牛仔帽老爺爺",
    "locations": ['雜貨店'],
    "first": [
      "田園野菇派",
      "布丁",
      "時髦手環",
      "發光手錶"
    ],
    "second": [
      "粉蝶花",
      "香菇",
      "鴻喜菇",
      "松茸",
      "醃漬香菇",
      "蜂蜜布丁",
      "咖啡布丁",
      "洋菇",
      "粉紅珊瑚菇",
      "杏鮑菇",
    ],
    "third": [
      "蜂巢蜜",
      "工蜂乳",
      "蜂王乳",
      "春風進行曲",
      "珠寶戒指",
      "炎帝華爾滋",
      "大地協奏曲",
      "蜂蜜",
      "珠寶墜子",
      "月夜夜曲",
      "彩虹花束",
      "雪花輪舞曲",
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "關",
    "description": "花店爺爺",
    "locations": ['花店'],
    "first": [
      "奇妙的釣餌"
    ],
    "second": [
      '白色天堂鳥',
      '炎帝華爾滋',
      '盆栽',
      '泰式咖哩蟹',
      '三種牡丹餅',
      '百花香水',
      '細葉榕',
      '魅惑香水',
      '大地協奏曲',
      '愛心榕',
      '花香香水',
      '果香香水',
      '水中霸主釣餌',
      '大果木棉',
      '月夜夜曲',
      '彩虹花束',
      '春風進行曲',
      '單朵插花',
      '泰式酸辣鯰魚湯',
      '韓式年糕湯',
      '花瓶',
      '雪花輪舞曲',
      '泰式涼拌冬粉沙拉'
    ],
    "third": [
      // "向日葵種子",
      '竹筍',
      '秋海棠',
      '黑色三色堇',
      '黑薔薇',
      '陸蓮花',
      '風鈴草',
      '栗子最中餅',
      '富貴菊',
      '鐵線蓮',
      '蟹類釣餌',
      '瑪格麗特',
      '時髦手環',
      '巨大農作物種子加工機',
      '巨大幼苗加工機',
      '巨大菇類種菌加工機',
      '聖誕玫瑰',
      '扶桑花',
      '珠寶墜子',
      '珠寶戒指',
      '芒果糯米飯',
      '大型魚類釣餌',
      '百合',
      '萬壽菊',
      '中型魚類釣餌',
      '艾草大福',
      '乒乓菊',
      '粉蝶花',
      '三色堇',
      '矮牽牛',
      '報春花',
      '玫瑰',
      '農作物種子加工機',
      '幼苗加工機',
      '發光手錶',
      '蝦類釣餌',
      '小型魚類釣餌',
      '菇類種菌加工機',
      '烏賊類釣餌',
      '草莓大福',
      '向日葵',
      '鬱金香'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "馬可斯",
    "description": "漁夫",
    "locations": ['馬可斯的家'],
    "first": [
      "巨大蕃薯",
      "巨大海鮮披薩",
      "堅果瑪芬蛋糕"
    ],
    "second": [
      '拿波里水煮魚',
      '魅惑香水',
      '巧克力瑪芬蛋糕',
      '時髦手環',
      '酥炸鮪魚塊',
      '果香香水',
      '義式烤扁鱈',
      '楓糖瑪芬蛋糕',
      '旗魚壽司',
      '義大利漁夫麵',
      '鯛魚生魚片',
      '葡萄牙海鮮銅鍋料理',
      '發光手錶',
      '蕃薯'
    ],
    "third": [
      '日式煮魚',
      '泰式咖哩蟹',
      '西班牙風醃漬沙丁魚',
      '馬賽魚湯',
      '百花香水',
      '西班牙式鐵板煎菇',
      '乾燒明蝦',
      '蛤蜊巧達濃湯',
      '花香香水',
      '捕魚網',
      '萬能捕魚網',
      '巨大捕魚網' ,
      '烤魚',
      '烤大雀鱔',
      '珠寶墜子',
      '珠寶戒指',
      '麻辣螯蝦',
      '龍宮湯',
      '海鮮蓋飯',
      '蚌殼湯',
      '泰式炸蝦吐司',
      '醃漬小魚',
      '天婦羅',
      '泰式酸辣湯',
      '鮪魚三明治',
      '鰻魚飯',
      '泰式涼拌冬粉沙拉'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "勞爾",
    "description": "桃紅色T恤,武士頭",
    "locations": ['馬可斯的家'],
    "first": [
      "香蕉",
      "美乃滋",
      "香蕉牛奶",
      "香蕉果醬",
      "時髦手環"
    ],
    "second": [
      '拿波里水煮魚',
      '炎帝華爾滋',
      '泰式咖哩蟹',
      '酥炸鮪魚塊',
      '巨大美乃滋加工機',
      '巨大海鮮披薩',
      '烤大雀鱔',
      '義式烤扁鱈',
      '珠寶墜子',
      '麻辣螯蝦',
      '旗魚壽司',
      '美乃滋加工機',
      '義大利漁夫麵',
      '鯛魚生魚片',
      '葡萄牙海鮮銅鍋料理',
      '醃漬小魚'
    ],
    "third": [
      '日式煮魚',
      '西班牙風醃漬沙丁魚',
      '馬賽魚湯',
      '軟軟球',
      '西班牙式鐵板煎菇',
      '乾燒明蝦',
      '蛤蜊巧達濃湯',
      '高級寵物零食',
      '巨大捕魚網',
      '烤魚',
      '珠寶戒指',
      '萬能捕魚網',
      '捕魚網',
      '龍宮湯',
      '寵物零食',
      '海鮮蓋飯',
      '蚌殼湯',
      '發光手錶',
      '泰式炸蝦吐司',
      '天婦羅',
      '泰式酸辣湯',
      '鮪魚三明治',
      '鰻魚飯',
      '泰式涼拌冬粉沙拉'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "道節",
    "description": "少主侍從",
    "locations": ['清心庵'],
    "first": [
      "巨大的青蔥",
      "飯糰",
      "栗子最中餅"
    ],
    "second": [
      '日式煮魚',
      '日式蔬菜豆腐湯',
      '日式炒牛蒡',
      '豆皮烏龍麵',
      '青蔥',
      '乒乓菊',
      '蚌殼湯',
      '醬油',
      '天婦羅'
    ],
    "third": [
      '竹筍',
      '炎帝華爾滋',
      '盆栽',
      '三種牡丹餅',
      '款冬',
      '栗子',
      '栗子飯',
      '白飯',
      '大地協奏曲',
      '屏風',
      '時髦手環',
      '烤魚',
      '筆頭菜',
      '日式白湯鍋',
      '珠寶墜子',
      '珠寶戒指',
      '泡菜鍋',
      '松茸炊飯',
      '拌飯',
      '月夜夜曲',
      '艾草大福',
      '秋葵湯',
      '紅豆麻糬湯',
      '方形紙罩座燈',
      '彩虹花束',
      '稻米',
      '紫萁',
      '樹汁',
      '發光手錶',
      '春風進行曲',
      '草莓大福',
      '茶葉',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "諾曼",
    "description": "地中海禿",
    "locations": ['食材店'],
    "first": [
      '蘋果果醬',
      '蘋果汁',
      '烤蘋果',
      '黃金蘋果',
      '奇妙的釣餌'
    ],
    "second": [
      "蘋果",
      "水中霸主釣餌",
      "馬鈴薯沙拉",
      "芬蘭甜菜沙拉",
      "時髦手環",
      "發光手錶"
    ],
    "third": [
      '炎帝華爾滋',
      '百花香水',
      '奶油加工機',
      '可可亞',
      '魅惑香水',
      '起司加工機',
      '液體調味料加工機',
      '蟹類釣餌',
      '大地協奏曲',
      '香精加工機',
      '花香香水',
      '果香香水',
      '巨大奶油加工機',
      '巨大起司加工機',
      '巨大液體調味料加工機',
      '巨大香精加工機',
      '巨大蜂蜜加工機',
      '巨大果醬加工機',
      '巨大美乃滋加工機',
      '巨大粉末加工機',
      '巨大調味料加工機',
      '巨大優格加工機',
      '蜂蜜加工機',
      '果醬加工機',
      '珠寶墜子',
      '珠寶戒指',
      '大型魚類釣餌',
      '美乃滋加工機',
      '中型魚類釣餌',
      '牛奶',
      '頂級牛奶',
      '月夜夜曲',
      '粉末加工機',
      '彩虹花束',
      '調味料加工機',
      '蝦類釣餌',
      '小型魚類釣餌',
      '春風進行曲',
      '烏賊類釣餌',
      '雪花輪舞曲',
      '優格加工機'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "最喜番",
    "description": "孤獨的美食家",
    "locations": ['最喜番的家'],
    "first": [
      // "香菇",
      '拿波里水煮魚',
      '西班牙烤大蔥',
      '義式番茄起司沙拉',
      '西班牙式鐵板煎菇',
      '烤大雀鱔',
      '飯糰',
      '薩赫蛋糕'
    ],
    "second": [
      '香料咖哩炒秋葵',
      '時髦手環',
      '分岔白蘿蔔',
      '巨大酪梨',
      '巨大的青蔥',
      '巨大蕃薯',
      '巨大番茄',
      '巨大蕪菁',
      '黃金蘋果',
      '黃金白菜',
      '黃金桃子',
      '黃金草莓',
      '義式烤扁鱈',
      '愛心菠菜',
      '珠寶哈密瓜',
      '義式蔬菜湯',
      '彩色玉蜀黍',
      '義大利漁夫麵',
      '彩虹花束',
      '普羅旺斯燉菜',
      '圓球茄子',
      '發光手錶',
      '星型馬鈴薯',
      '番茄汁'
    ],
    "third": [
      // "烤魚",
      '杏仁餅乾',
      '蘋果汁',
      '烤蘋果',
      '茄汁焗豆',
      '香蕉牛奶',
      '豆子沙拉',
      '黑森林蛋糕',
      '炎帝華爾滋',
      '日式煮魚',
      '燉馬鈴薯',
      '日式燉菜',
      '泰式咖哩蟹',
      '西班牙風醃漬沙丁魚',
      '羅宋湯',
      '三種牡丹餅',
      '馬賽魚湯',
      '百花香水',
      '日式炸浸蔬菜',
      '布朗尼蛋糕',
      '頂級水牛奶' ,
      '摩卡',
      '地瓜燒',
      '奶油培根蛋黃麵',
      '印度奶茶',
      '魅惑香水',
      '瑞士起司火鍋',
      '起司蛋糕',
      '栗子最中餅',
      '栗子飯',
      '乾燒明蝦',
      '巧克力蛋糕',
      '巧克力餅乾',
      '巧克力瑪芬蛋糕',
      '中華拉麵',
      '蛤蜊巧達濃湯',
      '可可亞',
      '椰子汁',
      '咖啡布丁',
      '餅乾',
      '白醬義大利麵',
      '咖哩飯',
      '大地協奏曲',
      '頂級雞蛋',
      '雞蛋沙拉',
      '雞蛋三明治',
      '異國風味咖哩',
      '花香香水',
      '法式吐司',
      '荷包蛋',
      '酥炸鮪魚塊',
      '水果歐蕾',
      '糖漬水果',
      '蒙布朗',
      '月夜夜曲',
      '艾草大福',
      '洋菇高麗菜捲',
      '醃漬香菇',
      '田園野菇派',
      '日式拿坡里義大利麵',
      '堅果瑪芬蛋糕',
      '龍宮湯',
      '秋葵湯',
      '歐姆蛋',
      '焗烤洋蔥湯',
      '柳橙汁',
      '紅豆麻糬湯',
      '美式鬆餅',
      '西班牙杏仁糕點',
      '義式奶酪',
      '蒜味辣椒義大利麵',
      '披薩',
      '法式燉菜湯',
      '布丁',
      '法式鹹派',
      '碗豆燉飯',
      '海鮮蓋飯',
      '鯛魚生魚片',
      '葡萄牙海鮮銅鍋料理',
      '大碗海鮮抓飯',
      '蚌殼湯',
      '草莓奶油蛋糕',
      '泰式炸蝦吐司',
      '頂級烏骨雞蛋',
      '醃漬小魚',
      '西班牙香蒜湯',
      '櫻桃冷湯',
      '春風進行曲',
      '奶油燉菜',
      '草莓大福',
      '草莓牛奶',
      '天婦羅',
      '提拉米蘇',
      '泰式酸辣湯',
      '泰式酸辣鯰魚湯',
      '墨西哥玉米湯餅',
      '韓式年糕湯',
      '鮪魚三明治',
      '鰻魚飯',
      '蔬菜汁',
      '蔬食披薩',
      '蔬菜沙拉',
      '蔬菜三明治',
      '法式煎蔬菜',
      '雪花輪舞曲',
      '黃色蔬菜濃湯',
      '優酪乳',
      '泰式涼拌冬粉沙拉'
    ],
    "isMarriageCandidate": false,
    "gender": "M"
  },
  {
    "name": "葛洛莉雅",
    "description": "鎮長太太",
    "locations": ['鎮公所', '博物館'],
    "first": [
      "黃金草莓",
      "百花香水",
      "大地協奏曲",
      "珠寶墜子"
    ],
    "second": [
      "糖漬水果",
      "炎帝華爾滋",
      '春風進行曲',
      '魅惑香水',
      '鑽石',
      '祖母綠',
      '紅寶石',
      '藍寶石',
      '花香香水',
      '果香香水',
      '法式吐司',
      '水果蛋糕',
      '珠寶戒指',
      '月夜夜曲',
      '彩虹花束',
      '雪花輪舞曲',
      '秋葵湯',
      '報春花',
      '草莓果醬',
      '草莓',
      '草莓牛奶',
    ],
    "third": [
      '龍涎香',
      '白色古文書',
      '黑色古文書',
      '古代貝類化石',
      '古代節肢動物化石',
      '古代飾品',
      '古代擺飾',
      '古代鏡子',
      '古代石碑',
      '古老的齒輪',
      '水砷鐵銅石',
      '洞穴珍珠',
      '黃金牛角頭盔',
      '黃金號角',
      '閃亮的冠軍皮帶扣',
      '閃亮的馬刺',
      '沙漠玫瑰',
      '恐龍化石',
      '時髦手環',
      '閃電熔結岩',
      '吉丙隕石',
      '橄欖隕鐵',
      '兔尾石',
      '琥珀結晶',
      '玻璃鞋',
      '紅綠柱石',
      '發光手錶',
      '老舊的硬幣',
      '老舊的羅盤',
      '老舊的團扇',
      '老舊的地圖',
      '老舊的卷軸',
      '白色蛋白石',
      '橄欖結晶',
      '果香香水',
      '水果沙拉',
      '水果蛋糕',
      '青醬義大利麵',
      '巨大海鮮披薩',
      '頂級山羊奶',
      '葡萄汁',
      '焗烤通心粉',
      '綠色蔬菜濃湯',
      '烤魚',
      '香草茶',
      '蜂蜜檸檬汁',
      '蜂蜜牛奶可可',
      '蜂蜜拿鐵',
      '蜂蜜布丁',
      '蜂蜜優格',
      '蜂蜜地瓜燒',
      '酸辣湯',
      '熱牛奶',
      '日式白湯鍋',
      '黃豆粉烤年糕吐司',
      '果醬三明治',
      '珠寶墜子',
      '珠寶戒指',
      '日式蔬菜豆腐湯',
      '芒果糯米飯',
      '泡菜',
      '泡菜鍋',
      '日式炒牛蒡',
      '豆皮烏龍麵',
      '拉明頓蛋糕',
      '希臘檸檬湯',
      '洋蔥拌炒馬鈴薯',
      '麻辣螯蝦',
      '芒果汁',
      '楓糖瑪芬蛋糕',
      '旗魚壽司',
      '松茸炊飯',
      '頂級牛奶',
      '夢幻原木',
      '夢幻木材',
      '拌飯',
      '綜合沙拉',
      '綜合蔬菜湯'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "派翠西亞",
    "locations": ['動物商店'],
    "first": [
      "黃金桃子",
      "月夜夜曲",
      "珠寶墜子"
    ],
    "second": [
      '黑森林蛋糕',
      '炎帝華爾滋',
      '蜂巢蜜',
      '大地協奏曲',
      '祖母綠',
      '時髦手環',
      '水果歐蕾',
      '水果蛋糕',
      '灰色兔毛毛料',
      '蜂蜜',
      '珠寶戒指',
      '奶茶',
      '焗烤洋蔥湯',
      '桃子',
      '桃子果醬',
      '矮牽牛',
      '桃色兔毛毛料',
      '兔毛毛料',
      '彩虹花束',
      '碗豆燉飯',
      '蜂王乳',
      '發光手錶',
      '春風進行曲',
      '茶',
      '雪花輪舞曲',
      '工蜂乳'
    ],
    "third": [
      '軟軟球',
      '百花香水',
      '魅惑香水',
      '高級寵物零食',
      '花香香水',
      '果香香水',
      '灰色兔毛',
      '頂級灰色兔毛',
      '灰色兔毛線',
      '老鼠球',
      '寵物零食',
      '桃色兔毛',
      '頂級桃色兔毛',
      '桃色兔毛線',
      '兔毛',
      '頂級兔毛',
      '兔毛線'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "莎莉",
    "description": "咖啡廳金髮貴婦",
    "locations": ['旅館＆咖啡廳'],
    "first": [
      "柳橙果醬",
      "百花香水",
      "珠寶戒指"
    ],
    "second": [
      '黑薔薇',
      '魅惑香水',
      '鐵線蓮',
      '時髦手環',
      '花香香水',
      '果香香水',
      '珠寶墜子',
      '柳橙',
      '柳橙汁',
      '美式鬆餅',
      '紅寶石',
      '發光手錶',
      '茶'
    ],
    "third": [
      // "檸檬",
      '炎帝華爾滋',
      '大地協奏曲',
      '金雨迷迭香',
      '芳香萬壽菊',
      '月夜夜曲',
      '奧勒岡葉',
      '彩虹花束',
      '鼠尾草',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "貝絲",
    "description": "紅毛雙馬尾眼鏡娘",
    "locations": ['博物館', '旅館＆咖啡廳'],
    "first": [
      '龍涎香',
      '黑色古文書',
      '古代節肢動物化石',
      '古代貝類化石',
      '白色古文書',
      '古代飾品',
      '古代擺飾',
      '古代鏡子',
      '古代石碑',
      '水砷鐵銅石',
      '洞穴珍珠',
      '黃金牛角頭盔',
      '琥珀結晶',
      '沙漠玫瑰',
      '恐龍化石',
      '閃電熔結岩',
      '吉丙隕石',
      '玻璃鞋',
      '黃金號角',
      '兔尾石',
      '橄欖結晶',
      '橄欖隕鐵',
      '古老的齒輪',
      '閃亮的冠軍皮帶扣',
      '發光手錶',
      '閃亮的馬刺',
      '老舊的硬幣',
      '老舊的羅盤',
      '老舊的團扇',
      '老舊的地圖',
      '老舊的卷軸'
    ],
    "second": [
      '炎帝華爾滋',
      '泰式咖哩蟹',
      '乾燒明蝦',
      '富貴菊',
      '咖哩飯',
      '大地協奏曲',
      '異國風味咖哩',
      '時髦手環',
      '酸辣湯',
      '泡菜',
      '泡菜鍋',
      '麻辣螯蝦',
      '月夜夜曲',
      '蒜味辣椒義大利麵',
      '彩虹花束',
      '春風進行曲',
      '泰式酸辣鯰魚湯',
      '雪花輪舞曲',
    ],
    "third": [
      "珠寶戒指",
      "珠寶墜子"
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "美紗希",
    "locations": ['小餐館'],
    "first": [
      "醃漬小魚",
      "醃漬香菇",
      "百花香水",
      "魅惑香水",
      "月夜夜曲",
      "雪花輪舞曲"
    ],
    "second": [
      '炎帝華爾滋',
      '奶油',
      '大地協奏曲',
      '時髦手環',
      '花香香水',
      '果香香水',
      '珠寶墜子',
      '珠寶戒指',
      '檸檬',
      '百合',
      '彩虹花束',
      '紅寶石',
      '發光手錶',
      '春風進行曲',
      '提拉米蘇'
    ],
    "third": [
      // "辣椒",
      '鮑魚',
      '大雀鱔',
      '極光魚',
      '軟絲',
      '赤貝',
      '藍蟹',
      '鯰魚',
      '起司',
      '可可粉',
      '鱈魚',
      '咖啡粉',
      '魷魚',
      '螯蝦',
      '墨魚',
      '珠星三塊魚',
      '鑽石',
      '鰻魚',
      '祖母綠',
      '比目魚',
      '麵粉',
      '三疣梭子蟹',
      '湄公河巨鯰',
      '泰國蝦',
      '龍膽石斑',
      '塔斯馬尼亞帝王蟹',
      '大王烏賊',
      '草蝦',
      '扁鱈',
      '鯡魚',
      '竹筴魚',
      '毛蟹',
      '大龍蝦',
      '鬼頭刀',
      '旗魚',
      '美乃滋',
      '虱目魚',
      '香草調味料',
      '辛辣調味料',
      '安康魚',
      '淡菜',
      '皇帶魚',
      '橄欖油',
      '牡蠣',
      '胡椒',
      '紅綠柱石',
      '伊勢龍蝦',
      '鮭魚',
      '鹽',
      '藍寶石',
      '沙丁魚',
      '花鱸',
      '鯛魚',
      '發光魚',
      '柳葉魚',
      '烏鱧',
      '松葉蟹',
      '醬油',
      '微光魚',
      '透抽',
      '雪花鴨嘴燕魟',
      '白星笛鯛',
      '砂糖',
      '吳郭魚',
      '鮪魚',
      '醋',
      '鬚赤蝦',
      '白色蛋白石',
      '黃鱸',
      '優格'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "潔西",
    "description": "老婆婆",
    "locations": ['雜貨店'],
    "first": [
      "蜂王乳",
      "蜂蜜布丁",
      "雪花輪舞曲"
    ],
    "second": [
      '炎帝華爾滋',
      '百花香水',
      '陸蓮花',
      '咖啡布丁',
      '蜂巢蜜',
      '大地協奏曲',
      '時髦手環',
      '蜂蜜',
      '蜂蜜檸檬汁',
      '蜂蜜牛奶可可',
      '蜂蜜拿鐵',
      '蜂蜜優格',
      '蜂蜜地瓜燒',
      '黃豆粉烤年糕吐司',
      '珠寶墜子',
      '珠寶戒指',
      '月夜夜曲',
      '醃漬香菇',
      '田園野菇派',
      '酸黃瓜',
      '布丁',
      '彩虹花束',
      '春風進行曲',
      '工蜂乳'
    ],
    "third": [
      '魅惑香水',
      '洋菇',
      '粉紅珊瑚菇',
      '花香香水',
      '果香香水',
      '蜂蜜巢蜜',
      '蜂巢巢蜜',
      '松茸',
      '蜂王巢蜜',
      '香菇',
      '鴻喜菇',
      '發光手錶',
      '石塊',
      '杏鮑菇',
      '白色蛋白石',
      '工蜂巢蜜'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "安琪拉",
    "description": "",
    "locations": ['雜貨店'],
    "first": [
      "咖啡布丁",
      "春風進行曲",
      "時髦手環",
    ],
    "second": [
      '炎帝華爾滋',
      '百花香水',
      '風鈴草',
      '櫻桃',
      '櫻桃果醬',
      '大地協奏曲',
      '果香香水',
      '蜂蜜布丁',
      '珠寶墜子',
      '珠寶戒指',
      '月夜夜曲',
      '胡椒',
      '布丁',
      '彩虹花束',
      '鹽',
      '藍寶石',
      '發光手錶',
      '草莓牛奶',
      '砂糖',
      '茶',
      '雪花輪舞曲'
    ],
    "third": [
      '羊駝毛毛料',
      '羊駝毛',
      '頂級羊駝毛',
      '羊駝毛線',
      '蘋果果醬',
      '香蕉果醬',
      '茶色羊駝毛毛料',
      '茶色羊駝毛',
      '頂級茶色羊駝毛',
      '茶色羊駝毛線',
      '奶油',
      '魅惑香水',
      '起司',
      '毛料加工機',
      '可可粉',
      '椰子果醬',
      '咖啡粉',
      '染料加工機',
      '花香香水',
      '麵粉',
      '巨大毛料加工機',
      '巨大染料加工機',
      '巨大布料加工機',
      '巨大毛線加工機',
      '葡萄果醬',
      '灰色兔毛毛料',
      '灰色兔毛',
      '頂級灰色兔毛',
      '灰色兔毛線',
      '檸檬果醬',
      '芒果果醬',
      '美乃滋',
      '哈密瓜果醬',
      '香草調味料',
      '辛辣調味料',
      '橄欖油',
      '柳橙果醬',
      '桃子果醬',
      '鳳梨果醬',
      '桃色兔毛毛料',
      '桃色兔毛',
      '頂級桃色兔毛',
      '桃色兔毛線',
      '兔毛毛料',
      '兔毛',
      '頂級兔毛',
      '兔毛線',
      '醬油',
      '草莓果醬',
      '薩福克羊毛毛料',
      '薩福克羊毛',
      '頂級薩福克羊毛',
      '薩福克羊毛線',
      '布料加工機',
      '醋',
      '西瓜果醬',
      '野莓',
      '羊毛',
      '頂級羊毛',
      '羊毛毛料',
      '羊毛線',
      '毛線加工機',
      '優格'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "辛蒂",
    "description": "小女孩",
    "locations": ['雜貨店'],
    "first": [
      "櫻桃冷湯",
      "蜂蜜布丁",
      "優酪乳",
      "櫻桃果醬",
      "春風進行曲"
    ],
    "second": [
      '炎帝華爾滋',
      '櫻桃',
      '咖啡布丁',
      '大地協奏曲',
      '時髦手環',
      '珠寶墜子',
      '珠寶戒指',
      '月夜夜曲',
      '布丁',
      '彩虹花束',
      '發光手錶',
      '菠菜泥優格沙拉',
      '鬱金香',
      '雪花輪舞曲',
      '優格'
    ],
    "third": [
      '羊駝毛毛料',
      '羊駝毛',
      '頂級羊駝毛',
      '羊駝毛線',
      '蘋果果醬',
      '香蕉果醬',
      '香蕉牛奶',
      '茶色羊駝毛毛料',
      '茶色羊駝毛',
      '頂級茶色羊駝毛',
      '茶色羊駝毛線',
      '椰子果醬',
      '水果歐蕾',
      '果香香水',
      '葡萄果醬',
      '灰色兔毛毛料',
      '灰色兔毛',
      '頂級灰色兔毛',
      '灰色兔毛線',
      '檸檬果醬',
      '芒果果醬',
      '哈密瓜果醬',
      '柳橙果醬',
      '桃子果醬',
      '鳳梨果醬',
      '桃色兔毛毛料',
      '桃色兔毛',
      '頂級桃色兔毛',
      '桃色兔毛線',
      '兔毛毛料',
      '兔毛',
      '頂級兔毛',
      '兔毛線',
      '草莓果醬',
      '草莓牛奶',
      '薩福克羊毛毛料',
      '薩福克羊毛',
      '頂級薩福克羊毛',
      '薩福克羊毛線',
      '西瓜果醬',
      '羊毛',
      '頂級羊毛',
      '羊毛毛料',
      '羊毛線'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "曼紐拉",
    "description": "漁夫太太",
    "locations": ['馬可斯的家'],
    "first": [
      "葡萄牙海鮮銅鍋料理",
      "水果歐蕾",
      "鳳梨果醬",
      "百花香水",
      "珠寶墜子"
    ],
    "second": [
      '拿波里水煮魚',
      '秋海棠',
      '魅惑香水',
      '祖母綠',
      '時髦手環',
      '花香香水',
      '糖漬水果',
      '果香香水',
      '義式烤扁鱈',
      '珠寶戒指',
      '旗魚壽司',
      '月夜夜曲',
      '義式奶酪',
      '義大利漁夫麵',
      '鳳梨',
      '鯛魚生魚片',
      '發光手錶',
      '醃漬小魚',
      '泰式涼拌冬粉沙拉'
    ],
    "third": [
      '炎帝華爾滋',
      '日式煮魚',
      '泰式咖哩蟹',
      '西班牙風醃漬沙丁魚',
      '馬賽魚湯',
      '西班牙式鐵板煎菇',
      '乾燒明蝦',
      '蛤蜊巧達濃湯',
      '大地協奏曲',
      '酥炸鮪魚塊',
      '巨大捕魚網',
      '巨大海鮮披薩',
      '烤魚',
      '烤大雀鱔',
      '麻辣螯蝦',
      '萬能捕魚網',
      '捕魚網',
      '龍宮湯',
      '彩虹花束',
      '海鮮蓋飯',
      '蚌殼湯',
      '泰式炸蝦吐司',
      '春風進行曲',
      '天婦羅',
      '泰式酸辣湯',
      '鮪魚三明治',
      '鰻魚飯',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "席妮",
    "description": "女強人",
    "first": [
      "優格",
      "葡萄汁",
      "葡萄果醬",
      "百花香水",
      "炎帝華爾滋",
      "發光手錶"
    ],
    "second": [
      '黑薔薇',
      '魅惑香水',
      '鑽石',
      '大地協奏曲',
      '時髦手環',
      '花香香水',
      '果香香水',
      '葡萄',
      '珠寶墜子',
      '珠寶戒指',
      '月夜夜曲',
      '西班牙杏仁糕點',
      '彩虹花束',
      '春風進行曲',
      '番茄汁',
      '蔬菜汁',
      '雪花輪舞曲'
    ],
    "third": [
      "可可豆",
      "祖母綠",
      "芬蘭甜菜沙拉",
      "茶"
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "卡琳娜",
    "description": "黑皮設計師",
    "locations": ['美人沙龍'],
    "first": [
      '百花香水',
      '大地協奏曲',
      '時髦手環',
      '果香香水',
      '巨大酪梨'
    ],
    "second": [
      '黑色三色堇',
      '炎帝華爾滋',
      '義式番茄起司沙拉',
      '魅惑香水',
      '花香香水',
      '青醬義大利麵',
      '珠寶墜子',
      '珠寶戒指',
      '希臘檸檬湯',
      '穿衣鏡',
      '月夜夜曲',
      '彩虹花束',
      '紅寶石',
      '發光手錶',
      '春風進行曲',
      '茶',
      '墨西哥玉米湯餅',
      '雪花輪舞曲'
    ],
    "third": [
      '酪梨',
      '豆子沙拉',
      '鑽石',
      '雞蛋沙拉',
      '水果沙拉',
      '綠色蔬菜濃湯',
      '蜂蜜檸檬汁',
      '洋蔥拌炒馬鈴薯',
      '綜合沙拉',
      '醃漬香菇',
      '酸黃瓜',
      '芬蘭甜菜沙拉',
      '藍寶石',
      '醃漬小魚',
      '蔬菜沙拉',
      '黃色蔬菜濃湯',
      '優酪乳'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "琴",
    "description": "白色短髮美容師",
    "locations": ['美人沙龍'],
    "first": [
      '百花香水',
      '摩卡',
      '魅惑香水',
      '花香香水',
      '果香香水',
      '拉明頓蛋糕',
      '發光手錶'
    ],
    "second": [
      '黑森林蛋糕',
      '布朗尼蛋糕',
      '巧克力蛋糕',
      '巧克力餅乾',
      '巧克力瑪芬蛋糕',
      '可可亞',
      '可可粉',
      '祖母綠',
      '時髦手環',
      '蜂蜜牛奶可可',
      '珠寶墜子',
      '珠寶戒指',
      '穿衣鏡' ,
      '三色堇',
      '彩虹花束',
      '薩赫蛋糕',
      '提拉米蘇'
    ],
    "third": [
      '酪梨',
      '炎帝華爾滋',
      '可可亞',
      '鑽石',
      '大地協奏曲',
      '巨大酪梨',
      '月夜夜曲',
      '紅寶石',
      '藍寶石',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": false,
    "gender": "F"
  },
  {
    "name": "小琳",
    "description": "",
    "locations": ['花店'],
    "first": [
      '珠寶墜子',
      '芒果糯米飯',
      '芒果',
      '芒果果醬',
      '芒果汁',
      '雪花輪舞曲'
    ],
    "second": [
      '蘋果汁',
      '白色天堂鳥',
      '炎帝華爾滋',
      '盆栽',
      '泰式咖哩蟹',
      '三種牡丹餅',
      '百花香水',
      '細葉榕',
      '印度奶茶',
      '栗子最中餅',
      '椰子汁',
      '大地協奏曲',
      '愛心榕',
      '花香香水',
      '葡萄汁',
      '聖誕玫瑰',
      '香草茶',
      '珠寶戒指',
      '夢幻布料',
      '大果木棉',
      '月夜夜曲',
      '艾草大福',
      '彩虹花束',
      '春風進行曲',
      '草莓大福',
      '茶',
      '單朵插花',
      '泰式酸辣鯰魚湯',
      '韓式年糕湯',
      '花瓶',
      '泰式涼拌冬粉沙拉'
    ],
    "third": [
      '秋海棠',
      '黑色三色堇',
      '黑薔薇',
      '陸蓮花',
      '風鈴草',
      '魅惑香水',
      '富貴菊',
      '鐵線蓮',
      '瑪格麗特',
      '時髦手環',
      '果香香水',
      '扶桑花',
      '百合',
      '萬壽菊',
      '夢幻草',
      '夢幻絲線',
      '乒乓菊',
      '粉蝶花',
      '三色堇',
      '矮牽牛',
      '報春花',
      '玫瑰',
      '發光手錶',
      '觸感柔滑的布料',
      '向日葵',
      '堅韌的布料',
      '鬱金香'
    ],
    "isMarriageCandidate": true,
    "gender": "F"
  },
  {
    "name": "布萊兒",
    "description": "金髮女孩",
    "locations": ['旅館＆咖啡廳'],
    "first": [
      '百花香水',
      '風鈴草',
      '瑪格麗特',
      '鑽石',
      '時髦手環',
      '果香香水',
      '發光手錶',
      '春風進行曲'
    ],
    "second": [
      '香蕉牛奶',
      '炎帝華爾滋',
      '布朗尼蛋糕',
      '魅惑香水',
      '櫻桃',
      '大地協奏曲',
      '雞蛋沙拉',
      '花香香水',
      '水果歐蕾',
      '水果沙拉',
      '玻璃鞋',
      '綠色蔬菜濃湯',
      '珠寶墜子',
      '珠寶戒指',
      '奶茶',
      '綜合沙拉',
      '月夜夜曲',
      '醃漬香菇',
      '馬鈴薯沙拉',
      '彩虹花束',
      '玫瑰',
      '醃漬小魚',
      '草莓牛奶',
      '茶',
      '蔬菜汁',
      '蔬菜沙拉',
      '雪花輪舞曲',
      '優酪乳'
    ],
    "third": [
      "白色蛋白石",
      "紅寶石",
      "藍寶石",
      "祖母綠",
      "紅綠柱石"
    ],
    "isMarriageCandidate": true,
    "gender": "F"
  },
  {
    "name": "菈菈",
    "description": "觀光導遊",
    "locations": ['食材店', '觀光服務中心'],
    "first": [
      '大雀鱔',
      '炎帝華爾滋',
      '百花香水',
      '魅惑香水',
      '時髦手環',
      '湄公河巨鯰',
      '龍膽石斑',
      '旗魚',
      '安康魚',
      '皇帶魚',
      '橄欖',
      '雪花鴨嘴燕魟',
      '鮪魚'
    ],
    "second": [
      '蘋果汁',
      '葡萄汁',
      '蜂蜜檸檬汁',
      '珠寶墜子',
      '珠寶戒指',
      '芒果汁',
      '萬壽菊',
      '柳橙汁',
      '紅寶石',
      '發光手錶',
      '向日葵',
      '蔬菜汁'
    ],
    "third": [
      '大地協奏曲',
      '花香香水',
      '果香香水',
      '月夜夜曲',
      '彩虹花束',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": true,
    "gender": "F"
  },
  {
    "name": "蕾娜",
    "description": "博物館",
    "locations": ['博物館'],
    "first": [
      // "芒果汁",
      '龍涎香',
      '黑色古文書',
      '水砷鐵銅石',
      '百花香水',
      '洞穴珍珠', //.75>1
      '魅惑香水',
      '黃金牛角頭盔',
      '琥珀結晶',
      '沙漠玫瑰',
      '恐龍化石',
      '閃電熔結岩',
      '吉丙隕石',
      '玻璃鞋',
      '黃金號角',
      '珠寶墜子',
      '檸檬', //4 > 4.25
      '檸檬果醬',
      '希臘檸檬湯',
      '月夜夜曲',
      '兔尾石',
      '橄欖結晶',
      '橄欖隕鐵',
      '閃亮的冠軍皮帶扣',
      '發光手錶',
      '閃亮的馬刺',
      '老舊的硬幣',
      '老舊的羅盤',
      '老舊的團扇',
      '老舊的地圖',
      '老舊的卷軸',
      '古代節肢動物化石',
      '古代貝類化石',
      '白色古文書',
      '古代飾品',
      '古代擺飾',
      '古代鏡子',
      '古代石碑',
      '古老的齒輪',
    ],
    "second": [
      '蘋果果醬',
      '香蕉果醬',
      '櫻桃果醬',
      '鐵線蓮',
      '椰子果醬',
      '祖母綠',
      '時髦手環',
      '玻璃',
      '葡萄果醬',
      '香草茶',
      '珠寶戒指',
      '穿衣鏡',
      '芒果果醬',
      '哈密瓜果醬',
      // Mysterious Plushie,
      '柳橙',
      '柳橙果醬',
      '桃子果醬',
      '鳳梨果醬',
      '草莓果醬',
      '西瓜果醬',
    ],
    "third": [
      '杏仁',
      '蘋果',
      '香蕉',
      '炎帝華爾滋',
      '可可豆',
      '櫻桃',
      '椰子',
      '鑽石',
      '大地協奏曲',
      '花香香水',
      '果香香水',
      '玻璃石',
      '黃金蘋果',
      '黃金桃子',
      '葡萄',
      '芒果',
      '桃子',
      '彩虹花束',
      '鑽石原石',
      '祖母綠原石',
      '紅寶石原石',
      '藍寶石原石',
      '紅寶石',
      '藍寶石',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": true,
    "gender": "F"
  },
  {
    "name": "布莉琪",
    "locations": ['動物商店'],
    "first": [
      '頂級水牛奶',
      '頂級山羊奶',
      '珠寶戒指',
      '頂級牛奶',
      '彩虹花束'
    ],
    "second": [
      // "高級飼料",
      '黑森林蛋糕',
      '起司蛋糕',
      '巧克力蛋糕',
      //  Deluxe Fodder,
      '頂級雞蛋',
      '時髦手環',
      '水果蛋糕',
      '黃金桃子',
      '珠寶墜子',
      '蒙布朗',
      '粉蝶花',
      '焗烤洋蔥湯',
      '三色堇',
      '桃子',
      '碗豆燉飯',
      '薩赫蛋糕',
      '草莓奶油蛋糕',
      '頂級烏骨雞蛋',
      '薩福克羊毛毛料',
      '提拉米蘇',
      '羊毛毛料'
    ],
    "third": [
      // "普通飼料",
      '熊雕像',
      '炎帝華爾滋',
      '青鳥雕像',
      '軟軟球',
      '百花香水',
      '茶色白鼬雕像',
      '水牛奶',
      '魅惑香水',
      '老鷹雕像',
      '大地協奏曲',
      '雞蛋',
      '游隼雕像',
      '高級寵物零食',
      '花香香水',
      '乾草飼料',
      '果香香水',
      '山羊奶',
      '牛奶',
      '猴子雕像',
      '月夜夜曲',
      '老鼠球',
      '黃色狐狸雕像',
      '貓頭鷹雕像',
      '寵物零食',
      '岩雷鳥雕像',
      '發光手錶',
      '烏骨雞蛋',
      '麻雀雕像',
      '春風進行曲',
      '松鼠雕像',
      '薩福克羊毛',
      '頂級薩福克羊毛',
      '薩福克羊毛線',
      '白色白鼬雕像',
      '白色狐狸雕像',
      '雪花輪舞曲',
      '羊毛',
      '頂級羊毛',
      '羊毛線'
    ],
    "isMarriageCandidate": true,
    "gender": "F"
  },
  {
    "name": "拉夫",
    "description": "巡林員",
    "locations": ['木工店'],
    "first": [
      "法式燉菜湯",
      "時髦手環"
    ],
    "second": [
      '拿波里水煮魚',
      '羅宋湯',
      '馬賽魚湯',
      '百花香水',
      '麵包',
      '蛤蜊巧達濃湯',
      '玉米麵包',
      '花香香水',
      '西班牙冷湯',
      '綠色蔬菜濃湯',
      '酸辣湯',
      '珠寶墜子',
      '日式蔬菜豆腐湯',
      '希臘檸檬湯',
      '義式蔬菜湯',
      '綜合蔬菜湯',
      '龍宮湯',
      '秋葵湯',
      '洋蔥麵包',
      '焗烤洋蔥湯',
      '蚌殼湯',
      '發光手錶',
      '西班牙香蒜湯',
      '櫻桃冷湯',
      '泰式酸辣湯',
      '韓式年糕湯',
      '黃色蔬菜濃湯'
    ],
    "third": [
      '炎帝華爾滋',
      '魅惑香水',
      '大地協奏曲',
      '果香香水',
      '珠寶戒指',
      '月夜夜曲',
      '彩虹花束',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": true,
    "gender": "M"
  },
  {
    "name": "伊織",
    "description": "日本武士",
    "locations": ['清心庵'],
    "first": [
      "松茸",
      "奇妙的釣餌",
      "飯糰",
      "發光手錶"
    ],
    "second": [
      '盆栽',
      '百花香水',
      '鐵線蓮',
      '水中霸主釣餌',
      '旗魚壽司',
      '松茸炊飯',
      '鯛魚生魚片',
      '香菇',
      '鴻喜菇',
      '醬油',
      '雪花輪舞曲'
    ],
    "third": [
      '炎帝華爾滋',
      '日式煮魚',
      '三種牡丹餅',
      '魅惑香水',
      '栗子最中餅',
      '栗子飯',
      '洋菇',
      '粉紅珊瑚菇',
      '蟹類釣餌',
      '大地協奏曲',
      '屏風',
      '時髦手環',
      '花香香水',
      '果香香水',
      '烤魚',
      '珠寶墜子',
      '珠寶戒指',
      '日式炒牛蒡',
      '大型魚類釣餌',
      '中型魚類釣餌',
      '拌飯',
      '月夜夜曲',
      '艾草大福',
      '龍宮湯',
      '紅豆麻糬湯',
      '方形紙罩座燈',
      '彩虹花束',
      '稻米',
      '蚌殼湯',
      '蝦類釣餌',
      '小型魚類釣餌',
      '春風進行曲',
      '烏賊類釣餌',
      '草莓大福',
      '天婦羅',
      '杏鮑菇',
      '鰻魚飯'
    ],
    "isMarriageCandidate": true,
    "gender": "M"
  },
  {
    "name": "艾米里歐",
    "description": "漁夫兒子,花襯衫",
    "locations": ['馬可斯的家'],
    "first": [
      "西瓜",
      "義大利漁夫麵",
      "珠寶墜子",
      "時髦手環"
    ],
    "second": [
      "向日葵",
      "醃漬小魚",
      "拿波里水煮魚",
      "起司蛋糕",
      "珠寶戒指",
      "黑森林蛋糕",
      "炎帝華爾滋",
      "泰式咖哩蟹",
      "魅惑香水",
      "巧克力蛋糕",
      "酥炸鮪魚塊",
      "果香香水",
      "水果蛋糕",
      "巨大海鮮披薩",
      "義式烤扁鱈",
      "麻辣螯蝦",
      "蒙布朗",
      "薩赫蛋糕",
      "鯛魚生魚片",
      "葡萄牙海鮮銅鍋料理",
      "發光手錶",
      "草莓奶油蛋糕",
      "提拉米蘇",
      "西瓜果醬",
      "旗魚壽司",
    ],
    "third": [
      // "蕪菁種子",
      // "洋蔥",
      // "番茄",
      // "橙",
      // "奶",
      '捕魚網',
      '萬能捕魚網',
      '巨大捕魚網',
      "日式煮魚",
      "西班牙風醃漬沙丁魚",
      "馬賽魚湯",
      "西班牙式鐵板煎菇",
      "乾燒明蝦",
      "蛤蜊巧達濃湯",
      "春風進行曲",
      "大地協奏曲",
      "月夜夜曲",
      "雪花輪舞曲",
      "彩虹花束",
      "花香香水",
      "百花香水",
      "烤魚",
      "龍宮湯",
      "蚌殼湯",
      "海鮮蓋飯",
      "泰式炸蝦吐司",
      "天婦羅",
      "泰式酸辣湯",
      "鮪魚三明治",
      "鰻魚飯",
      "泰式涼拌冬粉沙拉",
      "烤大雀鱔",
    ],
    "isMarriageCandidate": true,
    "gender": "M"
  },
  {
    "name": "傑克",
    "description": "雜貨店兒子",
    "locations": ['雜貨店'],
    "first": [
      "杏仁",
      "中華拉麵",
      "發光手錶",
      "大熊木雕"
    ],
    "second": [
      '黑色古文書',
      '古代節肢動物化石',
      '古代貝類化石',
      '白色古文書',
      '古代飾品',
      '古代擺飾',
      '古代鏡子',
      '古代石碑',
      '豆子',
      '咖啡',
      '咖啡布丁',
      '黃金牛角頭盔',
      '恐龍化石',
      '時髦手環',
      '黑色古文書的仿製品',
      '古代節肢動物化石的仿製品',
      '古代貝類化石的仿製品',
      '白色古文書的仿製品',
      '古代擺飾的仿製品',
      '古代鏡子的仿製品',
      '古代石碑的仿製品',
      '黃金牛角頭盔的仿製品',
      '恐龍化石的仿製品',
      '玻璃鞋的仿製品',
      '黃金號角的仿製品',
      '古老的齒輪的仿製品',
      '閃亮的冠軍皮帶扣的仿製品',
      '閃亮的馬刺的仿製品',
      '老舊的硬幣的仿製品',
      '老舊的羅盤的仿製品',
      '老舊的團扇的仿製品',
      '老舊的地圖的仿製品',
      '老舊的卷軸的仿製品',
      '水果歐蕾',
      '果香香水',
      '玻璃鞋',
      // Globe,
      '黃金號角',
      '蜂蜜布丁',
      '珠寶墜子',
      '珠寶戒指',
      // Old Map,
      '橄欖',
      '古老的齒輪',
      '布丁',
      '南瓜',
      '閃亮的冠軍皮帶扣',
      '閃亮的馬刺',
      '老舊的硬幣',
      '老舊的羅盤',
      '老舊的團扇',
      '老舊的地圖',
      '老舊的卷軸',
    ],
    "third": [
      '炎帝華爾滋',
      '百花香水',
      '魅惑香水',
      '大地協奏曲',
      '花香香水',
      '月夜夜曲',
      '彩虹花束',
      '春風進行曲',
      '雪花輪舞曲',
    ],
    "isMarriageCandidate": true,
    "gender": "M"
  },
  {
    "name": "戴蒙",
    "locations": ['動物商店'],
    "first": [
      "咖啡",
      "時髦手環",
      "發光手錶"
    ],
    "second": [
      '羊駝毛毛料',
      '龍涎香',
      '水砷鐵銅石',
      '黑色三色堇',
      '茶色羊駝毛毛料',
      '洞穴珍珠',
      '魅惑香水',
      '咖啡粉',
      '咖啡布丁',
      '琥珀結晶',
      '瑪格麗特',
      '沙漠玫瑰',
      '鑽石',
      '祖母綠',
      '閃電熔結岩',
      '吉丙隕石',
      '珠寶墜子',
      '兔尾石',
      '橄欖結晶',
      '焗烤洋蔥湯',
      '奧利哈鋼金屬塊',
      '橄欖隕鐵',
      '紅綠柱石',
      '碗豆燉飯',
      '紅寶石',
      '藍寶石',
      '白色蛋白石'
    ],
    "third": [
      // "銀礦石",
      '羊駝毛',
      '頂級羊駝毛',
      '羊駝毛線',
      '炎帝華爾滋',
      '百花香水',
      '茶色羊駝毛',
      '頂級茶色羊駝毛',
      '茶色羊駝毛線',
      '咖啡豆',
      '大地協奏曲',
      '花香香水',
      '果香香水',
      '玻璃',
      '金塊',
      '珠寶戒指',
      '月夜夜曲',
      '奧利哈鋼礦石',
      '彩虹花束',
      '鑽石原石',
      '祖母綠原石',
      '紅綠柱石原石',
      '紅寶石原石',
      '藍寶石原石',
      '白色蛋白石原石',
      '煤炭',
      '銀塊',
      '春風進行曲',
      '雪花輪舞曲'
    ],
    "isMarriageCandidate": true,
    "gender": "M"
  },
];

const neighborRawData = [];

neighborRawDataV1.forEach(role => {
  const roleData = {
    key: role.name,
    name: lang(role.name),
    description: lang(role.description ?? ''),
    locations: role.locations ? role.locations.map(rLoc => lang(locationRawData.find(loc => rLoc === loc.name).shortName) ) : [],
    isMarriageCandidate: role.isMarriageCandidate,
    gender: role.gender,
    gifts: [],
  }

  role.first.sort((a, b) => lang(a).localeCompare(lang(b))).forEach(gift => {
    roleData.gifts.push({key: gift, name: lang(gift), level: 1});
  });
  role.second.sort((a, b) => lang(a).localeCompare(lang(b))).forEach(gift => {
    roleData.gifts.push({key: gift, name: lang(gift), level: 2});
  });
  role.third.sort((a, b) => lang(a).localeCompare(lang(b))).forEach(gift => {
    roleData.gifts.push({key: gift, name: lang(gift), level: 3});
  });

  neighborRawData.push(roleData);
})

export default neighborRawData;